import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IMarginatorState {
  value: number;
  percentage: number;
  showCommission: boolean;
  showCommissionSelected: boolean;
  commission: number;
  supplier: string;
  showSupplier: boolean;
  showSupplierSelected: boolean;
  impersonator: IImpersonatorState;
  error: string;
}

export interface IImpersonatorState {
  memberId: number;
  storeType: string | null | undefined;
}

const initialState: IMarginatorState = {
  value: 0,
  percentage: 0,
  showCommission: false,
  showCommissionSelected: false,
  commission: 0,
  supplier: '',
  showSupplier: false,
  showSupplierSelected: false, 
  impersonator: {
    memberId: 0,
    storeType: null
  },
  error: '',
};

const marginatorSlice = createSlice({
  name: 'marginator',
  initialState,
  reducers: {
    setValue: (state: IMarginatorState, { payload }: PayloadAction<number>) => {
      state.value = payload;
    },
    setPercentage: (state: IMarginatorState, { payload }: PayloadAction<number>) => {
      state.percentage = payload / 100;
    },
    showCommission: (state: IMarginatorState, { payload }: PayloadAction<boolean>) => {
      state.showCommission = payload;
    },
    setCommission: (state: IMarginatorState, { payload }: PayloadAction<number>) => {
      state.commission = payload;
    },
    setSupplier: (state: IMarginatorState, { payload }: PayloadAction<string>) => {
      state.supplier = payload;
    },
    showSupplier: (state: IMarginatorState, { payload }: PayloadAction<boolean>) => {
      state.showSupplier = payload;
    },
    setMemberId: (state: IMarginatorState, { payload }: PayloadAction<number>) => {
      state.impersonator.memberId = payload;
    },
    setStoreType: (state: IMarginatorState, { payload }: PayloadAction<string | null | undefined>) => {
      state.impersonator.storeType = payload;
    },
    setError: (state: IMarginatorState, { payload }: PayloadAction<string>) => {
      state.error = payload;
    },
    setShowCommissionSelected: (state: IMarginatorState, { payload }: PayloadAction<boolean>) => {  
      state.showCommissionSelected = payload;
    },
    setShowSupplierSelected: (state: IMarginatorState, { payload }: PayloadAction<boolean>) => {
      state.showSupplierSelected = payload;
    }
  },
});

export const marginatorReducer = marginatorSlice.reducer;

export const marginatorActions = marginatorSlice.actions;